import { Component, Input } from '@angular/core';
import { PowerLines } from '@library/utils/constants/power-lines';
import { ConsumptionGroup } from '../../control-page-footer-consumption.component';
import { ControlPageFooterPowerlinesComponent } from '../control-page-footer-powerlines.component';
import { ControlPageFooterPowerlinesService } from '../control-page-footer-powerlines.service';

@Component({
  selector: 'app-control-page-powerlines-group',
  templateUrl: './control-page-powerlines-group.component.html',
  styleUrls: ['./control-page-powerlines-group.component.scss']
})
export class ControlPagePowerlinesGroupComponent {

  @Input() group: ConsumptionGroup;

  open = false;

  PowerLines = PowerLines;

  groups$ = this.parent.powerlinesGroups$;

  measureType$ = this.selectedPowerlinesGroup.measureType$;

  constructor(
    private selectedPowerlinesGroup: ControlPageFooterPowerlinesService,
    private parent: ControlPageFooterPowerlinesComponent,
  ) { }

  selectGroup(group: ConsumptionGroup) {
    this.selectedPowerlinesGroup.selectedGroup.next(group);
  }

  hasArrowSpace(groups: ConsumptionGroup[]) {
    return groups.some(g => g.rows.length > 1);
  }

}
